import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { SelectItem } from '@web/shared/ui';
import { Guid } from '@web/utils';
import { CollectionRequestBuilder } from '@web/common';
import { AdminBrandSocialMediaApiService } from '@web/shared/module/brand';

@Injectable({
  providedIn: 'root',
})
export class AdminBrandSocialMediaDataSourceService {
  /* prettier-ignore */
  private readonly adminBrandSocialMediaApi = inject(AdminBrandSocialMediaApiService);
  private readonly collectionRequestBuilder = inject(CollectionRequestBuilder);

  public fetchCollection(): Observable<SelectItem<Guid>[]> {
    const request = this.collectionRequestBuilder.disablePagination().build();

    return this.adminBrandSocialMediaApi
      .fetchCollection(request, true)
      .pipe(
        map((response) =>
          response.items.map(
            (item) => new SelectItem<Guid>(item.label, item.id),
          ),
        ),
      );
  }
}
